import React, {useEffect} from "react";
import {addDays, differenceInCalendarDays, format, isValid, isAfter} from "date-fns";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns";
import ruLocale from "date-fns/locale/ru";
import {Stack, TextField} from "@mui/material";
import {DatePicker} from "@mui/x-date-pickers/DatePicker";


export function DatePickerRangeDays({
                                        handle,
                                        day
                                    }) {
    const [start, setStart] = React.useState(null);
    const [end, setEnd] = React.useState(null);

    const tooLong = (
        start && end && day
            ? differenceInCalendarDays(end, start) > day
            : false
        ||(
                new Date(start).getFullYear() < 1900 ||
                new Date(start).getFullYear() > 2100 ||
                new Date(end).getFullYear() < 1900 ||
                new Date(end).getFullYear() > 2100
            )
    )
        || (!isValid(new Date(start)) || !isValid(new Date(end)));

    useEffect(() => {
        if (start && end && isValid(new Date(start)) && isValid(new Date(end)) && !tooLong) {
            const formattedStart = start ? format(start, "yyyy-MM-dd") : null;
            const formattedEnd = end ? format(end, "yyyy-MM-dd") : null;
            handle(formattedStart, formattedEnd)
        }else {
            handle(null, null)
        }

    }, [start, end, tooLong]);
    return (
        <LocalizationProvider
            dateAdapter={AdapterDateFns}
            adapterLocale={ruLocale}
        >
            <Stack direction="row" spacing={2}>
                {/* Начало диапазона */}
                <DatePicker
                    label="Дата начала"
                    value={start}
                    onChange={(newValue) => {

                        if (end && newValue && isAfter(newValue, end)) {
                            setEnd(null);
                        }

                        setStart(newValue);
                        if (day) { // есть ограничение
                            if (end && differenceInCalendarDays(end, newValue) > day) {
                                setEnd(null); // сбрасываем конец, если диапазон превышает day
                            }
                        }

                    }}
                    renderInput={(params) => <TextField {...params} size="small"/>}
                />

                {/* Конец диапазона */}
                <DatePicker
                    label="Дата конца"
                    value={end}
                    onChange={setEnd}
                    disabled={!start}
                    minDate={start}
                    maxDate={start && day ? addDays(start, day) : undefined}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            error={tooLong && start}
                            helperText={tooLong && start ? `Диапазон не может превышать ${day} дней` : ""}
                            size="small"
                        />
                    )}
                />
            </Stack>
        </LocalizationProvider>
    );
}